<template>
  <section class="manage-wrap" v-if="!isSpinner">
    <div>
      <Calculate :calcPrice="calcPriceData" />
      <dl class="calc-filters">
        <dt>날짜</dt>
        <dd>{{ searchDate }}</dd>
        <!-- <dt>상태</dt>
        <dd>전체</dd> -->
        <dt>정렬</dt>
        <dd>
          <a href="javascript:void(0);" @click="showSearch"
            >{{ orderby_text }} <i class="fal fa-angle-down"></i
          ></a>
        </dd>
      </dl>
      <calculate-list>
        <template slot="table-col">
          <col style="width: 114px;" />
          <col style="width: 130px;" />
          <col style="width: 210px;" />
          <col style="width: 210px;" />
          <col />
          <col style="width: 180px;" />
        </template>
        <template slot="table-header">
          <th>날짜</th>
          <th>정산 상태</th>
          <th>수익 A</th>
          <th>정산 완료된 금액 B</th>
          <th><span class="primary-color">정산 가능 금액</span> C=A-B</th>
          <th>비고</th>
        </template>
        <template slot="table-body" v-if="this.executeLists.length === 0">
          <tr>
            <td colspan="6">정산 내역이 없습니다.</td>
          </tr>
        </template>
        <template slot="table-body" v-else>
          <tr v-for="row in executeLists" :key="row.no">
            <td>{{ row.calc_date }}</td>
            <td>
              <span
                :class="
                  row.parent_seqno == null
                    ? 'default'
                    : row.status == '이월'
                    ? 'next'
                    : row.status == '완료'
                    ? 'complete'
                    : 'default'
                "
                >{{ row.parent_seqno == null ? '예정' : row.status }}</span
              >
            </td>
            <td class="number">
              <span
                @click="
                  $_moveSalesLookup(
                    row,
                    '',
                    row.parent_seqno == null ? row.total_price : 0
                  )
                "
                class="price-text"
                :class="{
                  'none-cursor':
                    row.parent_seqno != null || row.total_price == 0
                }"
              >
                {{
                  row.parent_seqno == null ? row.total_price : 0 | currency
                }}원
              </span>
            </td>
            <td class="number">
              <span
                @click="
                  $_moveSalesLookup(
                    row,
                    '',
                    row.parent_seqno != null ? row.total_price : 0
                  )
                "
                class="price-text"
                :class="{
                  'none-cursor':
                    row.parent_seqno == null || row.total_price == 0
                }"
              >
                {{
                  row.parent_seqno != null
                    ? '-' + row.total_price
                    : 0 | currency
                }}원
              </span>
            </td>
            <td class="number">
              <span
                @click="$_moveSalesLookup(row, 'possible', row.possible_price)"
                class="price-text primary-color"
                :class="{
                  'none-cursor':
                    row.possible_price == null || row.possible_price == 0
                }"
              >
                <b> {{ possiblePrice(row) | currency }}원 </b>
              </span>
            </td>
            <td>
              <span v-if="row.parent_seqno != null && row.status == '이월'">
                {{ row.memo }} (<span class="price-text">{{
                  row.possible_price | currency
                }}</span
                >)
              </span>
            </td>
          </tr>
        </template>
        <show-more
          slot="showmore"
          :currentCount="currentCount"
          :totalCount="totalCount"
          @showMore="showMore"
          v-show="totalCount > 15"
        />
        <ul class="manage-text" slot="contents">
          <li>
            정산 내역은 매월 3일에 업데이트됩니다. (영업일 기준 최대 2일이 더
            소요될 수 있습니다.)
          </li>
          <li>
            정산은 월별 50만 원 이상, 분기별 5만 원 이상 조건을 충족한 경우만
            진행됩니다. 조건을 미충족하지만, 정산을 원하시는 경우 담당자와
            협의해 주시기 바랍니다.
          </li>
          <li>
            정산 금액은 매월 3~7일에 정산 신청 후 세금계산서 발급과 입금 계좌
            정보를 등록한 경우, 해당 월 20일에 입금됩니다.
          </li>
          <li>
            정산 신청 후 세금계산서 발급과 입금 계좌 정보 등록을 누락한 경우,
            정산은 진행되지 않으며 이월 처리됩니다.
          </li>
          <li>
            정산 금액은 부가세 포함 금액입니다.
          </li>
        </ul>
      </calculate-list>

      <Modal
        v-show="showModal"
        :calcPrice="parseInt(calcPrice)"
        :bankInfo="bankInfo"
        @closeModal="closeModal"
      />
      <calculate-search
        v-show="showSearchModal"
        @searchCalculate="searchCalculate"
        @closeSearchModal="closeSearchModal"
      />
    </div>
  </section>
  <Spinner :loading="isSpinner" v-else />
</template>

<script>
import Calculate from '@/modules/Calculate.vue';
import CalculateList from '@/components/Table.vue';
import ShowMore from '@/components/ShowMore.vue';
import Modal from '@/components/Modal.vue';
import calculateSearch from '@/components/modal/CalculateSearch.vue';
import { $EventBus } from '@/utils/EventBus';
import Spinner from '@/components/Spinner.vue';

export default {
  filters: {
    currency(value) {
      return parseFloat(value)
        .toFixed(0)
        .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
    }
  },

  components: {
    Calculate,
    CalculateList,
    ShowMore,
    Modal,
    calculateSearch,
    Spinner
  },

  data() {
    return {
      // dummy
      showModal: false,
      showSearchModal: false,
      calcPriceData: {},
      current_page: 1,
      executeLists: [],
      calcPrice: 0,
      totalCount: 0,
      currentCount: 0,
      order_type: 'desc',
      start_date: '',
      end_date: '',
      isSpinner: false,
      bankInfo: { accountMask: '', accountName: '', bank: '' }
    };
  },

  created() {
    $EventBus.$on('show-modal', value => {
      this.showModal = value;
    });
  },

  beforeDestroy() {
    $EventBus.$off('show-modal');
  },

  computed: {
    toMonth() {
      let date = new Date();
      let month =
        date.getMonth() < 10 ? '0' + date.getMonth() : date.getMonth();
      return date.getFullYear() + '_' + month;
    },
    orderby_text() {
      return this.order_type == 'desc' ? '최신순' : '과거순';
    },
    searchDate() {
      let searchDate = '전체';

      if (this.start_date != '' && this.end_date != '') {
        searchDate = '직접 선택';
        /* let startDateSlice = this.start_date.split('-');
        let endDateSlice = this.end_date.split('-');

        if (
          startDateSlice[0] == endDateSlice[0] &&
          startDateSlice[1] == endDateSlice[1]
        ) {
          searchDate = startDateSlice[0] + '-' + startDateSlice[1];
        } else if (
          startDateSlice[0] != endDateSlice[0] ||
          startDateSlice[1] != endDateSlice[1]
        ) {
          searchDate =
            startDateSlice[0] +
            '-' +
            startDateSlice[1] +
            ' ~ ' +
            endDateSlice[0] +
            '-' +
            endDateSlice[1];
        } */
      }
      return searchDate;
    }
  },

  mounted() {
    this.$_fetchData();
    this.$_getCalculateExecute();
    this.$_getServiceBankInfo();
  },

  methods: {
    /** 정산 금액 조회[GET] */
    async $_fetchData() {
      await this.axios
        .get('/front/calculate')
        .then(response => {
          if (response.status != '200' && response.status != '204') {
            alert(
              '데이터를 가져오는 중 오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.'
            );
            location.replace('/');
          }
          if (response.status == '200') {
            this.calcPriceData = response.data;
            this.calcPrice = this.calcPriceData.calc_price;
          } else if (response.status == '204') {
            this.calcPrice = 0;
          }
        })
        .catch(error => {
          console.log('calculate fetchData failed', error);
        });
    },

    /** 정산 내역[GET] */
    $_getCalculateExecute() {
      this.isSpinner = true;
      this.axios
        .get('/front/calculateExecute', {
          params: {
            order_type: this.order_type,
            is_paging: 'Y',
            per_page: '15',
            page: this.current_page,
            start_date: this.start_date,
            end_date: this.end_date
          }
        })
        .then(response => {
          if (response.status == 200 || response.status == 204) {
            let data = response.data.data;
            for (const [key, value] of Object.entries(data)) {
              this.executeLists.push(value);
            }

            let pagination = response.data.pagination;

            this.totalCount = pagination.total_count;
            this.currentCount = pagination.per_page * pagination.current_page;
            this.currentCount =
              this.currentCount > this.totalCount
                ? this.totalCount
                : this.currentCount;
            this.isSpinner = false;
          } else {
            alert(
              '데이터를 가져오는 중 오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.'
            );
            location.replace('/');
          }
        })
        .catch(error => {
          console.log('calculateExecute fetchData failed', error);
        });
    },

    $_getServiceBankInfo() {
      this.axios
        .get('/front/reseller')
        .then(response => {
          if (response.status == 200) {
            let service = response.data.data[0];

            this.bankInfo.accountMask = service.calc_account_mask;
            this.bankInfo.accountName = service.calc_account_name;
            this.bankInfo.bank = service.calc_bank;
          } else {
            alert(
              '데이터를 가져오는 중 오류가 발생하였습니다.\n잠시 후 다시 시도해주세요.'
            );
          }
        })
        .catch(error => {
          console.log('reseller filter failed', error);
        });
    },

    $_moveSalesLookup(params, type, price) {
      if (price == 0) {
        return;
      }
      let obj = {};

      obj = {
        date: params.calc_date,
        total_price: price,
        payback_seqno: params.payback_seqno,
        parent_seqno: params.parent_seqno,
        type: type
      };
      let routeData = {
        name: 'SalesLookup',
        params: obj
      };
      this.$router.push(routeData);
    },
    possiblePrice(executeInfo) {
      if (executeInfo.possible_price == null) {
        return 0;
      }

      if (executeInfo.status == '이월') {
        return 0;
      }
      return executeInfo.possible_price;
    },
    showMore(status) {
      if (status == 'init') {
        this.executeLists = [];
        this.current_page = 1;
      } else {
        this.current_page += 1;
      }
      this.$_getCalculateExecute();
    },
    async closeModal(updateFetchData) {
      if (updateFetchData) {
        await this.$_fetchData();
      }
      this.showModal = false;
    },
    showSearch() {
      this.showSearchModal = true;
    },
    searchCalculate(params) {
      this.showSearchModal = false;

      this.start_date = params.start_date;
      this.end_date = params.end_date;
      this.order_type = params.orderby;
      this.executeLists = [];
      this.current_page = 1;
      this.$_getCalculateExecute();
    },
    closeSearchModal() {
      this.showSearchModal = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.manage-wrap {
  li {
    font-size: 14px;
    color: $text-gray1;

    &::before {
      display: inline-block;
      width: 14px;
      content: '\2022';
    }

    &:not(:last-child) {
      padding-bottom: 10px;
    }
  }
}

.manage-text {
  margin-top: 40px;
  margin-bottom: 40px;
}

.calc-filters {
  padding: 25px 0 10px;
  text-align: right;
  dt,
  dd {
    display: inline-block;
    font-size: 14px;
    line-height: 14px;
  }

  dt {
    color: $show-more;
    margin-right: 15px;
  }

  dd {
    &:not(:nth-last-of-type(1)) {
      padding-right: 20px;
      margin-right: 20px;
      border-right: 1px solid $border-color;
    }
  }
}
.price-text {
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }

  &.none-cursor {
    cursor: text !important;
    &:hover {
      text-decoration: none !important;
    }
  }
}
.reseller-table {
  margin-top: 10px;
  margin-bottom: 10px;

  th,
  td {
    color: $default-text;

    &.number {
      > span {
        color: $default-text;
      }
    }

    .default {
      color: $text-refund;
    }

    .next {
      color: $text-gray1;
    }

    .complete {
      color: $primary-color;
    }
  }
}
</style>
